export default __webpack_public_path__ + "static/media/4.5222ce54.png";